import type {Author as AuthorType, ProfileSubscriptionInfo} from './../types'
import UserModel from "~/repository/models/User";

export default class Author extends UserModel implements AuthorType {
    referral_code: string;
    is_followed: boolean
    subscription: ProfileSubscriptionInfo


    constructor(data: AuthorType) {
        super(data)
        this.referral_code = data.referral_code
        this.is_followed = data.is_followed
        this.subscription = data.subscription
    }
}
